import { render, staticRenderFns } from "./AddEditReadBooksCatalog.vue?vue&type=template&id=05f18f9f&scoped=true"
import script from "./AddEditReadBooksCatalog.vue?vue&type=script&lang=js"
export * from "./AddEditReadBooksCatalog.vue?vue&type=script&lang=js"
import style0 from "./AddEditReadBooksCatalog.vue?vue&type=style&index=0&id=05f18f9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f18f9f",
  null
  
)

export default component.exports